// extracted by mini-css-extract-plugin
export default {"pop_content_wrap":"ForgetPwd_pop_content_wrap__RI-LV","btn_start":"ForgetPwd_btn_start__NLTK7","animate-rotate":"ForgetPwd_animate-rotate__6fmR1"};